import { State } from 'src/types'
import { hamidashiOfNormal } from '../hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/ringFinger'
import { thumbEmbroideryDrawerForUsAtoms } from 'src/features/atoms/glove/drawer/common/back/useCanvasEmbroideries'
import { indexFingerLeft, indexFingerRight } from '../indexFinger'
import { littleFingerLeft, littleFingerRight } from '../littleFinger'
import { thumbAndWristBeltForErmWrist, thumbOut } from '../thumbAndWristBelt'
import { listBelt } from '../listBelt'
import { indexFingerPad } from '../fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from '../fingerCrotch'
import { catchFace2 } from '../catchFace2'
import { edgeOfBeltBackStyle } from '../edge/edgeOfBeltBackstyle'
import { edgeOfErmWrist, edgeOfWrist } from '../edge/edgeOfWrist'
import { middleFingerPad } from '../fingerCoverOrPad/middleFIngerPad'
import { thumbAndListBeltOfUsModel, thumbOutOfUsModel, thumbOverPartsUpperOfUsModel } from '../thumbAndListBeltOfUsModel'
import { hamidashiOfUsAtoms, thumbWeltingOfUsAtoms } from '../hamidashi/usAtoms'
import { littleFingerLeftForUs, littleFingerRightForUs } from '../littleFingerOfUsModel'
import { seriesChecker } from 'src/features/atoms/glove/simulationSpecification'
import { middleFingerCover } from '../fingerCoverOrPad/middleFingerCover'
import { ermBelt } from '../ermBelt'
import { thumbHook } from '../hooks/thumbHook'
import { usModelOfAtomsChecker } from 'src/logic'

// 通常ベルトモデル
export const beltBackStyleDrawer = async (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): Promise<void> => {
  if (['crownBackStyle', 'firstBackStyle'].includes(state.backStyle?.value)) return
  if (['crownBackStyle', 'firstBackStyle'].includes(state.baseModel?.backStyle)) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerCover = ['middleCover'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)
  const stitchColor = state.stitch.color
  const bindingColor = state.edge.color
  const printLeatherTypeValue = state.printLeatherType?.value

  // 親指指袋_手口ベルト(下地)
  await thumbAndWristBeltForErmWrist(ctx, state.thumbWeb?.color, printLeatherTypeValue)
  await thumbOut(ctx, state.thumbOut?.color, printLeatherTypeValue) // 親指＿外

  await indexFingerRight(ctx, state, needCatchFaceWrap, printLeatherTypeValue) // 人差し指＿右... UBackここで描いてる
  const { is2025Agl, is2025Apl, isDefaultWristBelt } = seriesChecker(state.baseModel.productNumber)
  if (isDefaultWristBelt) {
    await listBelt(ctx, state.listBelt?.color, stitchColor, printLeatherTypeValue)
  } else if (is2025Apl && !is2025Agl) {
    await ermBelt(ctx, state.listBelt.color, stitchColor, printLeatherTypeValue)
  }
  await indexFingerLeft(ctx, state.indexMiddle?.color, printLeatherTypeValue) //人差し指＿左
  await middleFingerRight(ctx, state.middleIndex?.color, printLeatherTypeValue) // 中指＿右
  await middleFingerLeft(ctx, state.middleRing?.color, printLeatherTypeValue) // 中指＿左
  await ringFingerRight(ctx, state.ringMiddle?.color, printLeatherTypeValue) // 薬指＿右
  await ringFingerLeft(ctx, state.ringLittle?.color, printLeatherTypeValue) // 薬指＿左
  // 小指
  await littleFingerRight(ctx, state.littleRing?.color, printLeatherTypeValue)
  await littleFingerLeft(ctx, state.littleOut?.color, printLeatherTypeValue)
  hamidashiOfNormal(ctx, state.hamidashi?.color)

  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace?.color, stitchColor, needCatchFaceWrap)
  edgeOfBeltBackStyle(ctx, state.edge?.color, stitchColor) // ヘリ革

  if (isDefaultWristBelt) {
    edgeOfWrist(ctx, bindingColor, stitchColor) // 投手用 && AGL
  } else {
    edgeOfErmWrist(ctx, bindingColor, stitchColor) // これ変える
  }

  if (isIndexFingerPad) {
    await indexFingerPad(ctx, state.indexCover.color, stitchColor, printLeatherTypeValue) // 指当て(人指し指)
  }
  if (isMiddleFingerPad) {
    await middleFingerPad(ctx, state.indexCover.color, stitchColor, -165, 90, -15, printLeatherTypeValue) // 指当て(中指)
  }
  fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch) // 指股
  if (isMiddleFingerCover) {
    await middleFingerCover(ctx, state.indexCover.color, stitchColor, -165, 90, -15, printLeatherTypeValue) // 指カバー(中指)
  }
  thumbHook(ctx, state.thumbHook.color, 110, -310, 15) // 先端 // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color, -14, 30, 0) //手元

  ctx.fillStyle = '#ffffff'
  ctx.beginPath()
  ctx.arc(327, 516, 6, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.arc(344, 560, 6, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// 通常ベルトモデル
export const usBeltBackStyleDrawer = async (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): Promise<void> => {
  const isUsModelOfAtoms = usModelOfAtomsChecker(state.baseModel.productNumber)
  if (!isUsModelOfAtoms) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerCover = ['middleCover'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)
  const stitchColor = state.stitch.color
  const bindingColor = state.edge.color
  const weltingColor = state.hamidashi.color
  const printLeatherTypeValue = state.printLeatherType?.value

  // 親指指袋_手口ベルト(下地)
  // ここでUS専用の描画
  thumbAndListBeltOfUsModel(ctx, state.thumbRoot?.color)
  thumbOutOfUsModel(ctx, state.thumbOut?.color) // 親指＿外
  thumbOverPartsUpperOfUsModel(ctx, state.thumbWeb?.color)
  indexFingerRight(ctx, state, needCatchFaceWrap, printLeatherTypeValue) // 人差し指＿右... UBackここで描いてる
  await indexFingerLeft(ctx, state.indexMiddle?.color, printLeatherTypeValue) // 人差し指＿左
  await middleFingerRight(ctx, state.middleIndex?.color, printLeatherTypeValue) // 中指＿右
  await middleFingerLeft(ctx, state.middleRing?.color, printLeatherTypeValue) // 中指＿左
  await ringFingerRight(ctx, state.ringMiddle?.color, printLeatherTypeValue) // 薬指＿右
  await ringFingerLeft(ctx, state.ringLittle?.color, printLeatherTypeValue) // 薬指＿左

  // 小指
  const isAJK05 = state.baseModel.productNumber === 'AJK-05'
  if (isAJK05) {
    await littleFingerRight(ctx, state.littleRing?.color, printLeatherTypeValue)
    await littleFingerLeft(ctx, state.littleOut?.color, printLeatherTypeValue)
    hamidashiOfNormal(ctx, weltingColor)
    thumbWeltingOfUsAtoms(ctx, weltingColor)
  } else {
    // ここでUS専用の描画
    littleFingerRightForUs(ctx, state.littleRing.color)
    littleFingerLeftForUs(ctx, state.littleOut.color)
    hamidashiOfUsAtoms(ctx, weltingColor)
  }
  catchFace2(ctx, state.catchFace?.color, stitchColor, needCatchFaceWrap) // 捕球面 / ウェブ下折り返し
  edgeOfBeltBackStyle(ctx, bindingColor, stitchColor) // ヘリ革
  edgeOfWrist(ctx, bindingColor, stitchColor) // ヘリ革

  if (isIndexFingerPad) {
    await indexFingerPad(ctx, state.indexCover.color, stitchColor, printLeatherTypeValue) // 指当て(人指し指)
  }
  if (isMiddleFingerPad) {
    await middleFingerPad(ctx, state.indexCover.color, stitchColor, -165, 90, -15, printLeatherTypeValue) // 指当て(中指)
  }
  fingerCrotch(ctx, state.catchFace.color, weltingColor, state.baseModel.isFingerCrotch)
  if (isMiddleFingerCover) {
    await middleFingerCover(ctx, state.indexCover.color, stitchColor, -165, 90, -15, printLeatherTypeValue) // 指カバー(中指)
  }
  thumbEmbroideryDrawerForUsAtoms(ctx, state.embroideries)
}
